import loadable from '@loadable/component';

export const FlipClock = loadable(() =>
  import(/* webpackChunkName: "flip-clock" */ './flip-clock')
);
